const TONE: Record<string, string> = {
  ok: "bg-ok/10 text-ok",
  warn: "bg-warn/10 text-warn",
  danger: "bg-danger/10 text-danger",
  info: "bg-accent-50 text-accent",
  neutral: "bg-black/[0.06] text-ink-muted",
};
export function Badge({ tone = "neutral", children }: { tone?: keyof typeof TONE | string; children: React.ReactNode }) {
  return <span className={`badge ${TONE[tone] ?? TONE.neutral}`}>{children}</span>;
}
